import { Outlet, Navigate, useLocation } from "react-router-dom";
import { DevLoginPanel } from "@/components/dev/DevLoginPanel";
import { useAuth } from "@/auth/useAuth";

export function AuthLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();
  // /login ha il suo layout split (art + form) a tutta larghezza e gestisce
  // da sé logo/header per ogni suo stato — niente chrome extra qui.
  const isLogin = location.pathname === "/login";

  // Se l'utente diventa loggato mentre è sulla pagina di login (es. dev-login
  // dal DevPanel), redirect verso il DashboardRedirect che sceglie la route
  // giusta in base al ruolo — oppure al deep-link originale (state.from,
  // impostato da ProtectedRoute) se il login nasce da un link diretto.
  if (!loading && user) {
    const from = (location.state as { from?: string } | null)?.from;
    return <Navigate to={from ?? "/"} replace />;
  }

  return (
    <div
      className={
        "min-h-screen flex items-center justify-center p-4 " +
        (isLogin
          ? "relative overflow-hidden bg-gradient-to-br from-[#0e2113] via-[#16321D] to-[#22482a]"
          : "bg-surface")
      }
    >
      {isLogin && (
        <>
          <div className="pointer-events-none absolute rounded-full border border-[#8de05a]/10" style={{ width: 700, height: 700, top: -200, right: -150 }} />
          <div className="pointer-events-none absolute rounded-full border border-[#8de05a]/10" style={{ width: 400, height: 400, bottom: -120, left: -80 }} />
        </>
      )}
      {isLogin ? (
        <Outlet />
      ) : (
        <div className="w-full max-w-sm">
          <div className="text-center mb-6">
            <img src="/logo.png" alt="AIEnergia" className="h-10 mx-auto" />
            <div className="text-sm text-muted-foreground mt-2">Accedi al tuo portale</div>
          </div>
          <Outlet />
        </div>
      )}
      <DevLoginPanel />
    </div>
  );
}
